import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkReportingUnitFieldsFragment = { __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence };

export type GrowerBenchmarkClassificationFacetFieldsFragment = { __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string };

export type GrowerBenchmarkFirmFieldsFragment = { __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> };

export type GrowerBenchmarkRosterEntryFieldsFragment = { __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean };

export type GrowerBenchmarkCommunityFieldsFragment = { __typename?: 'GrowerBenchmarkCommunity', communityId: string, name: string, segment: Types.GrowerBenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> };

export type GrowerBenchmarkSubmissionFieldsFragment = { __typename?: 'GrowerBenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.GrowerBenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.GrowerBenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null };

export type GetGrowerBenchmarkMyCommunitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGrowerBenchmarkMyCommunitiesQuery = { __typename?: 'Query', growerBenchmarkMyCommunities: Array<{ __typename?: 'GrowerBenchmarkCommunity', communityId: string, name: string, segment: Types.GrowerBenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> }> };

export type GrowerBenchmarkReviewReleaseFieldsFragment = { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin };

export type GrowerBenchmarkReviewSummaryFieldsFragment = { __typename?: 'GrowerBenchmarkReview', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, segment: Types.GrowerBenchmarkCommunitySegment, status: Types.GrowerBenchmarkReviewStatus, draftedAt: Types.TDateISO, release?: { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin } | null };

export type GetGrowerBenchmarkMyFirmsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGrowerBenchmarkMyFirmsQuery = { __typename?: 'Query', growerBenchmarkMyFirms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, growerBenchmarkMyReviews: Array<{ __typename?: 'GrowerBenchmarkReview', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, segment: Types.GrowerBenchmarkCommunitySegment, status: Types.GrowerBenchmarkReviewStatus, draftedAt: Types.TDateISO, release?: { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin } | null }> };

export type GetGrowerBenchmarkSubmissionsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  reportingUnitId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGrowerBenchmarkSubmissionsQuery = { __typename?: 'Query', growerBenchmarkSubmissions: Array<{ __typename?: 'GrowerBenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.GrowerBenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.GrowerBenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null }> };

export type GrowerBenchmarkMetricBandFieldsFragment = { __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null };

export type GrowerBenchmarkMetricFieldsFragment = { __typename?: 'GrowerBenchmarkMetric', communityId: string, metricKey: string, label: string, formula: string, inputs: Array<string>, direction: Types.GrowerBenchmarkMetricDirection, unit: string, decimalPlaces: number, groupKey: string, sortOrder: number, version: number, isActive: boolean, updatedAt: Types.TDateISO, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> };

export type GrowerBenchmarkFirmMetricFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetric', firmId: string, reportingUnitId: string, periodId: string, metricKey: string, value?: number | null, cohortKey: string, rankInCohort?: number | null, cohortSize?: number | null };

export type GrowerBenchmarkCohortStatisticFieldsFragment = { __typename?: 'GrowerBenchmarkCohortStatistic', cohortKey: string, periodId: string, cadence: Types.GrowerBenchmarkReportingCadence, metricKey: string, firmCount: number, reportedCount: number, median: number, lowerQuartile: number, topQuartile: number, minimum: number, maximum: number, priorPeriodMedian?: number | null, computedAt: Types.TDateISO, cohortFacets: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }> };

export type GrowerBenchmarkCohortPassRunFieldsFragment = { __typename?: 'GrowerBenchmarkCohortPassRun', runId: string, communityId: string, periodId: string, status: Types.GrowerBenchmarkCohortPassStatus, queuedAt: Types.TDateISO, startedAt?: Types.TDateISO | null, finishedAt?: Types.TDateISO | null, rowsWritten: number, cohortsWithheld: number, message?: string | null };

export type GetGrowerBenchmarkMetricCatalogQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  includeInactive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetGrowerBenchmarkMetricCatalogQuery = { __typename?: 'Query', growerBenchmarkMetricCatalog: Array<{ __typename?: 'GrowerBenchmarkMetric', communityId: string, metricKey: string, label: string, formula: string, inputs: Array<string>, direction: Types.GrowerBenchmarkMetricDirection, unit: string, decimalPlaces: number, groupKey: string, sortOrder: number, version: number, isActive: boolean, updatedAt: Types.TDateISO, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }> };

export type GetGrowerBenchmarkFirmMetricsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId: Types.Scalars['String']['input'];
  metricKey: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkFirmMetricsQuery = { __typename?: 'Query', growerBenchmarkFirmMetrics: Array<{ __typename?: 'GrowerBenchmarkFirmMetric', firmId: string, reportingUnitId: string, periodId: string, metricKey: string, value?: number | null, cohortKey: string, rankInCohort?: number | null, cohortSize?: number | null }> };

export type GetGrowerBenchmarkCohortStatisticsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId: Types.Scalars['String']['input'];
  metricKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
  cohortKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGrowerBenchmarkCohortStatisticsQuery = { __typename?: 'Query', growerBenchmarkCohortStatistics: Array<{ __typename?: 'GrowerBenchmarkCohortStatistic', cohortKey: string, periodId: string, cadence: Types.GrowerBenchmarkReportingCadence, metricKey: string, firmCount: number, reportedCount: number, median: number, lowerQuartile: number, topQuartile: number, minimum: number, maximum: number, priorPeriodMedian?: number | null, computedAt: Types.TDateISO, cohortFacets: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }> }> };

export type GetGrowerBenchmarkCohortPassRunsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGrowerBenchmarkCohortPassRunsQuery = { __typename?: 'Query', growerBenchmarkCohortPassRuns: Array<{ __typename?: 'GrowerBenchmarkCohortPassRun', runId: string, communityId: string, periodId: string, status: Types.GrowerBenchmarkCohortPassStatus, queuedAt: Types.TDateISO, startedAt?: Types.TDateISO | null, finishedAt?: Types.TDateISO | null, rowsWritten: number, cohortsWithheld: number, message?: string | null }> };

export type GrowerBenchmarkReviewQueueRowFieldsFragment = { __typename?: 'GrowerBenchmarkReviewQueueRow', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, status: Types.GrowerBenchmarkReviewStatus, instructionVersionId: string, instructionVersionNumber: number, draftedAt: Types.TDateISO, updatedAt: Types.TDateISO };

export type GrowerBenchmarkReviewFieldsFragment = { __typename?: 'GrowerBenchmarkReview', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, segment: Types.GrowerBenchmarkCommunitySegment, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null, analystEditSeconds: number, draftedAt: Types.TDateISO, approval?: { __typename?: 'GrowerBenchmarkReviewApproval', outputType: Types.GrowerBenchmarkReviewOutputType, approvedByUserId: string, approvedAt: Types.TDateISO, approvedVersionId: string, analystEditSeconds: number } | null, release?: { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin } | null, versions: Array<{ __typename?: 'GrowerBenchmarkReviewVersion', versionId: string, versionNumber: number, authorUserId: string, origin: Types.GrowerBenchmarkReviewVersionOrigin, instructionSetId: string, instructionVersionId: string, changedSectionIds: Array<string>, createdAt: Types.TDateISO, sections: Array<{ __typename?: 'GrowerBenchmarkReviewSection', sectionId: string, title: string, order: number, narrative: string, tiles: Array<{ __typename?: 'GrowerBenchmarkReviewTile', label: string, value: string, comparison?: string | null }>, tableRows: Array<{ __typename?: 'GrowerBenchmarkReviewTableRow', label: string, values: Array<string> }>, evidence: Array<{ __typename?: 'GrowerBenchmarkReviewEvidenceLink', metricKey: string, periodId: string, label: string }> }>, findingNotes: Array<{ __typename?: 'GrowerBenchmarkReviewFindingNote', metricKey: string, quote: string, attributedToUserId: string, attributedToName: string, writtenAt: Types.TDateISO }> }> };

export type GetGrowerBenchmarkReportQueueQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status?: Types.InputMaybe<Types.GrowerBenchmarkReviewStatus>;
}>;


export type GetGrowerBenchmarkReportQueueQuery = { __typename?: 'Query', growerBenchmarkReportQueue: Array<{ __typename?: 'GrowerBenchmarkReviewQueueRow', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, status: Types.GrowerBenchmarkReviewStatus, instructionVersionId: string, instructionVersionNumber: number, draftedAt: Types.TDateISO, updatedAt: Types.TDateISO }> };

export type GetGrowerBenchmarkReviewMeteringQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkReviewMeteringQuery = { __typename?: 'Query', growerBenchmarkReviewMetering: { __typename?: 'GrowerBenchmarkReviewMetering', communityId: string, periodId: string, perFirmReviewCount: number, retainerContentCount: number } };

export type GetGrowerBenchmarkReviewQueryVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkReviewQuery = { __typename?: 'Query', growerBenchmarkReview?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, segment: Types.GrowerBenchmarkCommunitySegment, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null, analystEditSeconds: number, draftedAt: Types.TDateISO, approval?: { __typename?: 'GrowerBenchmarkReviewApproval', outputType: Types.GrowerBenchmarkReviewOutputType, approvedByUserId: string, approvedAt: Types.TDateISO, approvedVersionId: string, analystEditSeconds: number } | null, release?: { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin } | null, versions: Array<{ __typename?: 'GrowerBenchmarkReviewVersion', versionId: string, versionNumber: number, authorUserId: string, origin: Types.GrowerBenchmarkReviewVersionOrigin, instructionSetId: string, instructionVersionId: string, changedSectionIds: Array<string>, createdAt: Types.TDateISO, sections: Array<{ __typename?: 'GrowerBenchmarkReviewSection', sectionId: string, title: string, order: number, narrative: string, tiles: Array<{ __typename?: 'GrowerBenchmarkReviewTile', label: string, value: string, comparison?: string | null }>, tableRows: Array<{ __typename?: 'GrowerBenchmarkReviewTableRow', label: string, values: Array<string> }>, evidence: Array<{ __typename?: 'GrowerBenchmarkReviewEvidenceLink', metricKey: string, periodId: string, label: string }> }>, findingNotes: Array<{ __typename?: 'GrowerBenchmarkReviewFindingNote', metricKey: string, quote: string, attributedToUserId: string, attributedToName: string, writtenAt: Types.TDateISO }> }> } | null };

export type GetGrowerBenchmarkMyReviewQueryVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkMyReviewQuery = { __typename?: 'Query', growerBenchmarkMyReview?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, firmId: string, reportingUnitId: string, reportingUnitLabel: string, periodId: string, segment: Types.GrowerBenchmarkCommunitySegment, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null, analystEditSeconds: number, draftedAt: Types.TDateISO, approval?: { __typename?: 'GrowerBenchmarkReviewApproval', outputType: Types.GrowerBenchmarkReviewOutputType, approvedByUserId: string, approvedAt: Types.TDateISO, approvedVersionId: string, analystEditSeconds: number } | null, release?: { __typename?: 'GrowerBenchmarkReviewRelease', releasedByUserId: string, releasedByName: string, releasedAt: Types.TDateISO, sectionCount: number, draftOrigin: Types.GrowerBenchmarkReviewVersionOrigin } | null, versions: Array<{ __typename?: 'GrowerBenchmarkReviewVersion', versionId: string, versionNumber: number, authorUserId: string, origin: Types.GrowerBenchmarkReviewVersionOrigin, instructionSetId: string, instructionVersionId: string, changedSectionIds: Array<string>, createdAt: Types.TDateISO, sections: Array<{ __typename?: 'GrowerBenchmarkReviewSection', sectionId: string, title: string, order: number, narrative: string, tiles: Array<{ __typename?: 'GrowerBenchmarkReviewTile', label: string, value: string, comparison?: string | null }>, tableRows: Array<{ __typename?: 'GrowerBenchmarkReviewTableRow', label: string, values: Array<string> }>, evidence: Array<{ __typename?: 'GrowerBenchmarkReviewEvidenceLink', metricKey: string, periodId: string, label: string }> }>, findingNotes: Array<{ __typename?: 'GrowerBenchmarkReviewFindingNote', metricKey: string, quote: string, attributedToUserId: string, attributedToName: string, writtenAt: Types.TDateISO }> }> } | null };

export type GetGrowerBenchmarkMyReviewPdfQueryVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkMyReviewPdfQuery = { __typename?: 'Query', growerBenchmarkMyReviewPdf: { __typename?: 'GrowerBenchmarkReviewPdfPayload', success: boolean, pdfBase64?: string | null, errorMessage?: string | null } };

export const GrowerBenchmarkClassificationFacetFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
    `, {"fragmentName":"GrowerBenchmarkClassificationFacetFields"});
export const GrowerBenchmarkReportingUnitFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
    `, {"fragmentName":"GrowerBenchmarkReportingUnitFields"});
export const GrowerBenchmarkFirmFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
    fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}`, {"fragmentName":"GrowerBenchmarkFirmFields"});
export const GrowerBenchmarkRosterEntryFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}
    `, {"fragmentName":"GrowerBenchmarkRosterEntryFields"});
export const GrowerBenchmarkCommunityFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCommunityFields on GrowerBenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...GrowerBenchmarkFirmFields
  }
  roster {
    ...GrowerBenchmarkRosterEntryFields
  }
}
    fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}`, {"fragmentName":"GrowerBenchmarkCommunityFields"});
export const GrowerBenchmarkSubmissionFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkSubmissionFields on GrowerBenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}
    `, {"fragmentName":"GrowerBenchmarkSubmissionFields"});
export const GrowerBenchmarkReviewReleaseFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}
    `, {"fragmentName":"GrowerBenchmarkReviewReleaseFields"});
export const GrowerBenchmarkReviewSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReviewSummaryFields on GrowerBenchmarkReview {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  segment
  status
  release {
    ...GrowerBenchmarkReviewReleaseFields
  }
  draftedAt
}
    fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}`, {"fragmentName":"GrowerBenchmarkReviewSummaryFields"});
export const GrowerBenchmarkMetricBandFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
    `, {"fragmentName":"GrowerBenchmarkMetricBandFields"});
export const GrowerBenchmarkMetricFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkMetricFields on GrowerBenchmarkMetric {
  communityId
  metricKey
  label
  formula
  inputs
  direction
  unit
  decimalPlaces
  bands {
    ...GrowerBenchmarkMetricBandFields
  }
  groupKey
  sortOrder
  version
  isActive
  updatedAt
}
    fragment GrowerBenchmarkMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}`, {"fragmentName":"GrowerBenchmarkMetricFields"});
export const GrowerBenchmarkFirmMetricFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmMetricFields on GrowerBenchmarkFirmMetric {
  firmId
  reportingUnitId
  periodId
  metricKey
  value
  cohortKey
  rankInCohort
  cohortSize
}
    `, {"fragmentName":"GrowerBenchmarkFirmMetricFields"});
export const GrowerBenchmarkCohortStatisticFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCohortStatisticFields on GrowerBenchmarkCohortStatistic {
  cohortKey
  cohortFacets {
    ...GrowerBenchmarkClassificationFacetFields
  }
  periodId
  cadence
  metricKey
  firmCount
  reportedCount
  median
  lowerQuartile
  topQuartile
  minimum
  maximum
  priorPeriodMedian
  computedAt
}
    fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}`, {"fragmentName":"GrowerBenchmarkCohortStatisticFields"});
export const GrowerBenchmarkCohortPassRunFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCohortPassRunFields on GrowerBenchmarkCohortPassRun {
  runId
  communityId
  periodId
  status
  queuedAt
  startedAt
  finishedAt
  rowsWritten
  cohortsWithheld
  message
}
    `, {"fragmentName":"GrowerBenchmarkCohortPassRunFields"});
export const GrowerBenchmarkReviewQueueRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReviewQueueRowFields on GrowerBenchmarkReviewQueueRow {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  status
  instructionVersionId
  instructionVersionNumber
  draftedAt
  updatedAt
}
    `, {"fragmentName":"GrowerBenchmarkReviewQueueRowFields"});
export const GrowerBenchmarkReviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReviewFields on GrowerBenchmarkReview {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  segment
  status
  approvedVersionId
  approval {
    outputType
    approvedByUserId
    approvedAt
    approvedVersionId
    analystEditSeconds
  }
  release {
    ...GrowerBenchmarkReviewReleaseFields
  }
  analystEditSeconds
  versions {
    versionId
    versionNumber
    authorUserId
    origin
    instructionSetId
    instructionVersionId
    changedSectionIds
    sections {
      sectionId
      title
      order
      narrative
      tiles {
        label
        value
        comparison
      }
      tableRows {
        label
        values
      }
      evidence {
        metricKey
        periodId
        label
      }
    }
    findingNotes {
      metricKey
      quote
      attributedToUserId
      attributedToName
      writtenAt
    }
    createdAt
  }
  draftedAt
}
    fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}`, {"fragmentName":"GrowerBenchmarkReviewFields"});
export const GetGrowerBenchmarkMyCommunitiesDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMyCommunities {
  growerBenchmarkMyCommunities {
    ...GrowerBenchmarkCommunityFields
  }
}
    fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}
fragment GrowerBenchmarkCommunityFields on GrowerBenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...GrowerBenchmarkFirmFields
  }
  roster {
    ...GrowerBenchmarkRosterEntryFields
  }
}`);
export const GetGrowerBenchmarkMyFirmsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMyFirms {
  growerBenchmarkMyFirms {
    ...GrowerBenchmarkFirmFields
  }
  growerBenchmarkMyReviews {
    ...GrowerBenchmarkReviewSummaryFields
  }
}
    fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}
fragment GrowerBenchmarkReviewSummaryFields on GrowerBenchmarkReview {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  segment
  status
  release {
    ...GrowerBenchmarkReviewReleaseFields
  }
  draftedAt
}`);
export const GetGrowerBenchmarkSubmissionsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkSubmissions($communityId: String!, $reportingUnitId: String, $periodId: String, $first: Int, $after: String) {
  growerBenchmarkSubmissions(
    communityId: $communityId
    reportingUnitId: $reportingUnitId
    periodId: $periodId
    first: $first
    after: $after
  ) {
    ...GrowerBenchmarkSubmissionFields
  }
}
    fragment GrowerBenchmarkSubmissionFields on GrowerBenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}`);
export const GetGrowerBenchmarkMetricCatalogDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMetricCatalog($communityId: String!, $includeInactive: Boolean) {
  growerBenchmarkMetricCatalog(
    communityId: $communityId
    includeInactive: $includeInactive
  ) {
    ...GrowerBenchmarkMetricFields
  }
}
    fragment GrowerBenchmarkMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkMetricFields on GrowerBenchmarkMetric {
  communityId
  metricKey
  label
  formula
  inputs
  direction
  unit
  decimalPlaces
  bands {
    ...GrowerBenchmarkMetricBandFields
  }
  groupKey
  sortOrder
  version
  isActive
  updatedAt
}`);
export const GetGrowerBenchmarkFirmMetricsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkFirmMetrics($communityId: String!, $periodId: String!, $metricKey: String!) {
  growerBenchmarkFirmMetrics(
    communityId: $communityId
    periodId: $periodId
    metricKey: $metricKey
  ) {
    ...GrowerBenchmarkFirmMetricFields
  }
}
    fragment GrowerBenchmarkFirmMetricFields on GrowerBenchmarkFirmMetric {
  firmId
  reportingUnitId
  periodId
  metricKey
  value
  cohortKey
  rankInCohort
  cohortSize
}`);
export const GetGrowerBenchmarkCohortStatisticsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkCohortStatistics($communityId: String!, $periodId: String!, $metricKey: String, $cohortKey: String) {
  growerBenchmarkCohortStatistics(
    communityId: $communityId
    periodId: $periodId
    metricKey: $metricKey
    cohortKey: $cohortKey
  ) {
    ...GrowerBenchmarkCohortStatisticFields
  }
}
    fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkCohortStatisticFields on GrowerBenchmarkCohortStatistic {
  cohortKey
  cohortFacets {
    ...GrowerBenchmarkClassificationFacetFields
  }
  periodId
  cadence
  metricKey
  firmCount
  reportedCount
  median
  lowerQuartile
  topQuartile
  minimum
  maximum
  priorPeriodMedian
  computedAt
}`);
export const GetGrowerBenchmarkCohortPassRunsDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkCohortPassRuns($communityId: String!, $periodId: String) {
  growerBenchmarkCohortPassRuns(communityId: $communityId, periodId: $periodId) {
    ...GrowerBenchmarkCohortPassRunFields
  }
}
    fragment GrowerBenchmarkCohortPassRunFields on GrowerBenchmarkCohortPassRun {
  runId
  communityId
  periodId
  status
  queuedAt
  startedAt
  finishedAt
  rowsWritten
  cohortsWithheld
  message
}`);
export const GetGrowerBenchmarkReportQueueDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkReportQueue($communityId: String!, $periodId: String, $status: GrowerBenchmarkReviewStatus) {
  growerBenchmarkReportQueue(
    communityId: $communityId
    periodId: $periodId
    status: $status
  ) {
    ...GrowerBenchmarkReviewQueueRowFields
  }
}
    fragment GrowerBenchmarkReviewQueueRowFields on GrowerBenchmarkReviewQueueRow {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  status
  instructionVersionId
  instructionVersionNumber
  draftedAt
  updatedAt
}`);
export const GetGrowerBenchmarkReviewMeteringDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkReviewMetering($communityId: String!, $periodId: String!) {
  growerBenchmarkReviewMetering(communityId: $communityId, periodId: $periodId) {
    communityId
    periodId
    perFirmReviewCount
    retainerContentCount
  }
}
    `);
export const GetGrowerBenchmarkReviewDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkReview($reviewId: String!) {
  growerBenchmarkReview(reviewId: $reviewId) {
    ...GrowerBenchmarkReviewFields
  }
}
    fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}
fragment GrowerBenchmarkReviewFields on GrowerBenchmarkReview {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  segment
  status
  approvedVersionId
  approval {
    outputType
    approvedByUserId
    approvedAt
    approvedVersionId
    analystEditSeconds
  }
  release {
    ...GrowerBenchmarkReviewReleaseFields
  }
  analystEditSeconds
  versions {
    versionId
    versionNumber
    authorUserId
    origin
    instructionSetId
    instructionVersionId
    changedSectionIds
    sections {
      sectionId
      title
      order
      narrative
      tiles {
        label
        value
        comparison
      }
      tableRows {
        label
        values
      }
      evidence {
        metricKey
        periodId
        label
      }
    }
    findingNotes {
      metricKey
      quote
      attributedToUserId
      attributedToName
      writtenAt
    }
    createdAt
  }
  draftedAt
}`);
export const GetGrowerBenchmarkMyReviewDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMyReview($reviewId: String!) {
  growerBenchmarkMyReview(reviewId: $reviewId) {
    ...GrowerBenchmarkReviewFields
  }
}
    fragment GrowerBenchmarkReviewReleaseFields on GrowerBenchmarkReviewRelease {
  releasedByUserId
  releasedByName
  releasedAt
  sectionCount
  draftOrigin
}
fragment GrowerBenchmarkReviewFields on GrowerBenchmarkReview {
  reviewId
  firmId
  reportingUnitId
  reportingUnitLabel
  periodId
  segment
  status
  approvedVersionId
  approval {
    outputType
    approvedByUserId
    approvedAt
    approvedVersionId
    analystEditSeconds
  }
  release {
    ...GrowerBenchmarkReviewReleaseFields
  }
  analystEditSeconds
  versions {
    versionId
    versionNumber
    authorUserId
    origin
    instructionSetId
    instructionVersionId
    changedSectionIds
    sections {
      sectionId
      title
      order
      narrative
      tiles {
        label
        value
        comparison
      }
      tableRows {
        label
        values
      }
      evidence {
        metricKey
        periodId
        label
      }
    }
    findingNotes {
      metricKey
      quote
      attributedToUserId
      attributedToName
      writtenAt
    }
    createdAt
  }
  draftedAt
}`);
export const GetGrowerBenchmarkMyReviewPdfDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMyReviewPdf($reviewId: String!) {
  growerBenchmarkMyReviewPdf(reviewId: $reviewId) {
    success
    pdfBase64
    errorMessage
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetGrowerBenchmarkMyCommunities: build.query<GetGrowerBenchmarkMyCommunitiesQuery, GetGrowerBenchmarkMyCommunitiesQueryVariables | void>({
      query: (variables) => ({ document: GetGrowerBenchmarkMyCommunitiesDocument, variables })
    }),
    GetGrowerBenchmarkMyFirms: build.query<GetGrowerBenchmarkMyFirmsQuery, GetGrowerBenchmarkMyFirmsQueryVariables | void>({
      query: (variables) => ({ document: GetGrowerBenchmarkMyFirmsDocument, variables })
    }),
    GetGrowerBenchmarkSubmissions: build.query<GetGrowerBenchmarkSubmissionsQuery, GetGrowerBenchmarkSubmissionsQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkSubmissionsDocument, variables })
    }),
    GetGrowerBenchmarkMetricCatalog: build.query<GetGrowerBenchmarkMetricCatalogQuery, GetGrowerBenchmarkMetricCatalogQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkMetricCatalogDocument, variables })
    }),
    GetGrowerBenchmarkFirmMetrics: build.query<GetGrowerBenchmarkFirmMetricsQuery, GetGrowerBenchmarkFirmMetricsQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkFirmMetricsDocument, variables })
    }),
    GetGrowerBenchmarkCohortStatistics: build.query<GetGrowerBenchmarkCohortStatisticsQuery, GetGrowerBenchmarkCohortStatisticsQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkCohortStatisticsDocument, variables })
    }),
    GetGrowerBenchmarkCohortPassRuns: build.query<GetGrowerBenchmarkCohortPassRunsQuery, GetGrowerBenchmarkCohortPassRunsQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkCohortPassRunsDocument, variables })
    }),
    GetGrowerBenchmarkReportQueue: build.query<GetGrowerBenchmarkReportQueueQuery, GetGrowerBenchmarkReportQueueQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkReportQueueDocument, variables })
    }),
    GetGrowerBenchmarkReviewMetering: build.query<GetGrowerBenchmarkReviewMeteringQuery, GetGrowerBenchmarkReviewMeteringQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkReviewMeteringDocument, variables })
    }),
    GetGrowerBenchmarkReview: build.query<GetGrowerBenchmarkReviewQuery, GetGrowerBenchmarkReviewQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkReviewDocument, variables })
    }),
    GetGrowerBenchmarkMyReview: build.query<GetGrowerBenchmarkMyReviewQuery, GetGrowerBenchmarkMyReviewQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkMyReviewDocument, variables })
    }),
    GetGrowerBenchmarkMyReviewPdf: build.query<GetGrowerBenchmarkMyReviewPdfQuery, GetGrowerBenchmarkMyReviewPdfQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkMyReviewPdfDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetGrowerBenchmarkMyCommunitiesQuery, useLazyGetGrowerBenchmarkMyCommunitiesQuery, useGetGrowerBenchmarkMyFirmsQuery, useLazyGetGrowerBenchmarkMyFirmsQuery, useGetGrowerBenchmarkSubmissionsQuery, useLazyGetGrowerBenchmarkSubmissionsQuery, useGetGrowerBenchmarkMetricCatalogQuery, useLazyGetGrowerBenchmarkMetricCatalogQuery, useGetGrowerBenchmarkFirmMetricsQuery, useLazyGetGrowerBenchmarkFirmMetricsQuery, useGetGrowerBenchmarkCohortStatisticsQuery, useLazyGetGrowerBenchmarkCohortStatisticsQuery, useGetGrowerBenchmarkCohortPassRunsQuery, useLazyGetGrowerBenchmarkCohortPassRunsQuery, useGetGrowerBenchmarkReportQueueQuery, useLazyGetGrowerBenchmarkReportQueueQuery, useGetGrowerBenchmarkReviewMeteringQuery, useLazyGetGrowerBenchmarkReviewMeteringQuery, useGetGrowerBenchmarkReviewQuery, useLazyGetGrowerBenchmarkReviewQuery, useGetGrowerBenchmarkMyReviewQuery, useLazyGetGrowerBenchmarkMyReviewQuery, useGetGrowerBenchmarkMyReviewPdfQuery, useLazyGetGrowerBenchmarkMyReviewPdfQuery } = injectedRtkApi;
